/**
 * Mensaje a mostrar ante un error de GraphQL del módulo de compras: los errores de
 * validación del backend (código BAD_USER_INPUT) se muestran tal cual; el resto, con un
 * mensaje genérico para no exponer detalles técnicos.
 */
export const mensajeError = (error, porDefecto = "Ha ocurrido un error, intente más tarde") =>
  error?.graphQLErrors?.find((e) => e?.extensions?.code === "BAD_USER_INPUT")?.message || porDefecto;
